module.exports = __webpack_public_path__ + "img/payment_tinaba.97ff96f6.png";